import { render, staticRenderFns } from "./bindMeasurePoint.vue?vue&type=template&id=a3327ffa&scoped=true"
import script from "./bindMeasurePoint.vue?vue&type=script&lang=js"
export * from "./bindMeasurePoint.vue?vue&type=script&lang=js"
import style0 from "./bindMeasurePoint.vue?vue&type=style&index=0&id=a3327ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3327ffa",
  null
  
)

export default component.exports